import React from 'react';
import { Container, Grid } from '@material-ui/core';
import {
  string,
  node,
  bool,
  oneOfType,
} from 'prop-types';
import styles from './ColumnSection.module.scss';
import HeadlineSmall from '../HeadlineSmall';
import HeadlineLarge from '../HeadlineLarge';
import variables from '../../styles/variables.module.scss';

const ColumnSection = ({
  headlineSmall,
  headlineLarge,
  stroke,
  title,
  body,
  backgroundColor,
  textColor,
  headlineLineBreak,
  isCase,
  children,
}) => (
  <section
    className={[
      styles.sectionContainer,
      isCase && styles.caseSectionContainer,
    ].join(' ')}
    style={{ backgroundColor }}
  >
    <Container>
      <Grid container direction="row">
        <Grid item xs={12} md={headlineLarge ? 12 : 6}>
          <HeadlineSmall color={textColor}>{headlineSmall}</HeadlineSmall>
        </Grid>
        {
          headlineLarge && (
            <Grid item xs={12} md={6}>
              <HeadlineLarge
                stroke={stroke}
                color={textColor}
                lineBreak={headlineLineBreak}
                className={styles.headlineLarge}
                medium
              >
                {headlineLarge}
              </HeadlineLarge>
            </Grid>
          )
        }
        <Grid item xs={12} md={6}>
          <Grid item>
            <h3 className={styles.titleSection} style={{ color: textColor }}>{title}</h3>
            <p style={{ color: textColor }}>{body}</p>
          </Grid>
          {children}
        </Grid>
      </Grid>
    </Container>
  </section>
);

ColumnSection.propTypes = {
  headlineSmall: string,
  headlineLarge: string,
  stroke: string,
  title: oneOfType([
    string,
    node,
  ]),
  body: oneOfType([
    string,
    node,
  ]),
  backgroundColor: string,
  textColor: string,
  children: node,
  headlineLineBreak: bool,
  isCase: bool,
};

ColumnSection.defaultProps = {
  headlineSmall: null,
  headlineLarge: null,
  stroke: null,
  title: null,
  body: null,
  backgroundColor: variables.tuna,
  textColor: variables.cleanWhite,
  children: null,
  headlineLineBreak: true,
  isCase: false,
};

export default ColumnSection;
